export default __webpack_public_path__ + "1.19.2/static/media/LibreDataShare_SimplifiedChinese.2e517bfd.svg";